import React from "react";
import { Row, Col, Form, Select } from "antd";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const FormSelect = (props) => {
  // -------------------------- VAR -----------------------------
  const name = props?.name || "Tên";
  const label = props?.label;
  const placeholder = props?.placeholder || "Nhập Tiêu Đề";
  const options = props?.options || [];
  const rules = props?.rules || [];
  const disabled = props?.disabled || false;
  const suffix = props?.suffix;
  const showSearch = props?.showSearch || false;
  const initialValue = options?.length > 0 ? options[0].value : "";
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderSuffix = () => {
    if (suffix) {
      return (
        <Row gutter={[10]}>
          <Col span={20}>
            <Form.Item
              name={name}
              label={label}
              initialValue={initialValue}
              rules={rules}
            >
              <Select
                placeholder={placeholder}
                options={options}
                showSearch={showSearch}
                disabled={disabled}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input?.toLowerCase()
                  )
                }
              />
            </Form.Item>
          </Col>
          <Col span={4}>{suffix}</Col>
        </Row>
      );
    } else {
      return (
        <Form.Item
          name={name}
          label={label}
          initialValue={initialValue}
          rules={rules}
        >
          <Select
            placeholder={placeholder}
            options={options}
            disabled={disabled}
            showSearch={showSearch}
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(
                input?.toLowerCase()
              )
            }
          />
        </Form.Item>
      );
    }
  };
  // -------------------------- MAIN ----------------------------
  return <>{renderSuffix()}</>;
};
export default FormSelect;
